var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('banner-page',{attrs:{"background-position":_vm.bannerBackgroundPosition,"img-src":require('@/assets/banners/blue-shapes-with-logo.svg'),"background-color":_vm.bannerBackgroundColor}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }